import { BadgeCheck } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { CtaButton } from "./CtaButton";

const PLANS = [
  { id: "month", name: "1 месяц", price: "449", suffix: "", total: null, label: null },
  { id: "halfyear", name: "6 месяцев", price: "299", suffix: "/мес", total: "1 794 ₽ за весь период", label: "Выгодно" },
  { id: "year", name: "12 месяцев", price: "219", suffix: "/мес", total: "2 628 ₽ за весь период", label: "Лучший выбор", best: true },
];

export default function Pricing({ onCta }) {
  return (
    <section id="pricing" className="py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Chapter n="04">Тарифы</Chapter>
        <Reveal delay={0.1}>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight md:text-4xl">
            Простая цена без сюрпризов
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p
            data-testid="pricing-note"
            className="mt-4 inline-flex items-center gap-2 rounded-full bg-nora-mint/10 px-4 py-2 text-sm font-semibold text-nora-mint"
          >
            <BadgeCheck className="h-4 w-4" />
            1 день бесплатно для новых пользователей · Отменить можно в любой момент
          </p>
        </Reveal>

        <div className="mt-12 grid items-stretch gap-5 md:grid-cols-3">
          {PLANS.map((p, i) => (
            <Reveal key={p.id} delay={0.15 + i * 0.12} className="h-full">
              <div
                data-testid={`pricing-card-${p.id}`}
                className={`relative flex h-full flex-col rounded-[2rem] p-8 text-center transition-transform duration-300 hover:-translate-y-2 ${
                  p.best
                    ? "border-2 border-nora-accent bg-nora-surface shadow-2xl shadow-nora-accent/15 md:-my-4 md:py-12"
                    : "border border-nora-ink/5 bg-nora-surface shadow-sm"
                }`}
              >
                {p.best && (
                  <span
                    data-testid="pricing-badge-best"
                    className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-nora-accent px-5 py-1.5 font-display text-xs font-bold text-[#1F2730] shadow-lg"
                  >
                    Лучший выбор
                  </span>
                )}
                <h3 className="font-display text-lg font-bold">{p.name}</h3>
                {p.label && !p.best && (
                  <span className="mx-auto mt-3 inline-block rounded-full bg-nora-mint/15 px-4 py-1 text-xs font-bold text-nora-mint">
                    {p.label}
                  </span>
                )}
                <div className="mt-6 flex-1">
                  <div className="whitespace-nowrap">
                    <span
                      className={`font-display font-black tracking-tight ${
                        p.best
                          ? "text-4xl text-nora-accent sm:text-5xl md:text-3xl lg:text-6xl"
                          : "text-4xl sm:text-5xl md:text-3xl lg:text-5xl"
                      }`}
                    >
                      {p.price} ₽
                    </span>
                    <span className="ml-1 text-nora-ink/55">{p.suffix}</span>
                  </div>
                  {p.total && (
                    <p className="mt-2 text-sm text-nora-ink/50">{p.total}</p>
                  )}
                </div>
                <div className="mt-8">
                  {p.best ? (
                    <CtaButton
                      onClick={onCta}
                      testId={`pricing-cta-${p.id}`}
                      className="w-full"
                      text="Попробовать бесплатно"
                    />
                  ) : (
                    <button
                      type="button"
                      data-testid={`pricing-cta-${p.id}`}
                      onClick={onCta}
                      className="w-full rounded-full border-2 border-nora-ink/15 px-6 py-3.5 font-display text-sm font-bold transition-colors hover:border-nora-accent hover:text-nora-accent"
                    >
                      Попробовать бесплатно
                    </button>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.4}>
          <p
            data-testid="pricing-legal-note"
            className="mx-auto mt-8 max-w-2xl text-center text-xs leading-relaxed text-nora-ink/45"
          >
            Оформляя подписку, вы соглашаетесь с{" "}
            <a
              href="/terms"
              className="font-semibold text-nora-accent hover:underline"
            >
              Офертой
            </a>{" "}
            и просите открыть доступ сразу. Возврат средств проводит App Store
            или Google Play по своим правилам.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
